module.exports = __webpack_public_path__ + "static/img/027政府诉求平台14.d911344.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/027政府诉求平台14.jpg
// module id = a82A
// module chunks = 0